import React from 'react';
import './footer.scss';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <p>&copy; 2025 SPARKDIT INC.</p>
        </footer>
    );
}

export default Footer;
